import { array } from 'js-md5';

/* 官方文档示例：https://help.aliyun.com/document_detail/32067.html */
const OSS = require('ali-oss');

const partSize = 1024 * 1024;// 每个分片大小(byte)
const parallel = 5;// 同时上传的分片数
const region = process.env.VUE_APP_OSS_REGION;//"oss-cn-shanghai"// 
const accessKeyId = process.env.VUE_APP_OSS_ACCESSKEYID;//'LTAI5tEaWvxTDrNtgJiLKFiF'// 
const accessKeySecret = process.env.VUE_APP_OSS_ACCESSKEYSECRET;//'ocC8rhzwOAAkEg7Ip7RoPsD5ZWtyDp'// 
const bucket = process.env.VUE_APP_OSS_BUCKET;//"xwkjoss";// 
const imageFolder = "images/";// 图片文件夹
const documentFolder = "documents/";// 文档文件夹
const audioFolder = "audios/";// 音频文件夹
const iconFolder = "icon/";// 图标文件夹
const apkFolder = "apk/";// 安卓安装包文件夹

// const OssUr = `https://${bucket}.${region}.aliyuncs.com/`;//https://xwkjoss.oss-cn-shanghai.aliyuncs.com/
const OssUr = `https://oss.yanzeedu.com/`;

const client = new OSS({
    region,
    accessKeyId,
    accessKeySecret,
    bucket
})

const progress = (p, _checkpoint) => {
    // Object的上传进度。
    console.log(p);
    // 分片上传的断点信息。
    console.log(_checkpoint);
};

// 调用Oss的sdk包进行上传
function ossUpload(fileName, File, type, fnProgress) {
    let path = "";
    switch (type) {
        case "1":// 图片
            path = imageFolder;
            break;
        case "2"://音频
            path = audioFolder;
            break;
        case "3"://文档
            path = documentFolder;
            break;
        case "4"://图标
            path = iconFolder;
            break;
        case "5"://apk
            path = apkFolder;
            break;
    }
    path = path + fileName
    if (File.size < (partSize * 10)) {
        return ossPut(path, File);
    } else {
        return ossmultipartUpload(path, File, fnProgress)
    }
}

// 预览资源
function ossPreview(fileName, type) {
    let path = OssUr;
    switch (type) {
        case "1":// 图片
            path = path + imageFolder;
            break;
        case "2"://音频
            path = path + audioFolder;
            break;
        case "3"://文档
            path = path + documentFolder;
            break;
        case "4"://图标
            path = path + iconFolder;
            break;
        case "5"://apk
            path = path + apkFolder;
            break;
    }
    path = path + fileName
    return path;
}

async function ossAbortMultipartUpload(name, uploadId) {
    const result = await client.abortMultipartUpload(name, uploadId);
}

// 删除Oss文件
function ossDelete(fileName, type) {
    if (typeof fileName == "string") {
        return ossDeleteFile(fileName, type);
    } else {
        return ossDeleteMulti(fileName, type);
    }
}

// 上传本地文件
function ossPut(fileName, File) {
    var headers = getHeader(File);
    return client.put(fileName, File, { headers });
}

// 分片上传
function ossmultipartUpload(fileName, File, fnProgress) {
    var headers = getHeader(File);
    return client.multipartUpload(fileName, File, { headers }, {
        parallel,
        partSize,
        progress: fnProgress,
    })
}

// 删除单个文件
async function ossDeleteFile(fileName, type) {
    try {
        // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
        let path = "";
        switch (type) {
            case "1":// 图片
                path = path + imageFolder;
                break;
            case "2"://音频
                path = path + audioFolder;
                break;
            case "3"://文档
                path = path + documentFolder;
                break;
            case "4"://图标
                path = path + iconFolder;
                break;
            case "5"://apk
                path = path + apkFolder;
                break;
        }
        path = path + fileName
        let result = await client.delete(path);
        console.log(result);
    } catch (e) {
        console.log(e);
    }
}

// 批量删除文件
async function ossDeleteMulti(fileNames, type) {
    if (fileNames instanceof Array) {
        try {
            let prefix = "";
            switch (type) {
                case "1":// 图片
                    prefix = imageFolder;
                    break;
                case "2"://音频
                    prefix = audioFolder;
                    break;
                case "3"://文档
                    prefix = documentFolder;
                    break;
                case "4"://图标
                    prefix = iconFolder;
                    break;
                case "5"://apk
                    prefix = apkFolder;
                    break;
            }
            fileNames.map(item => {
                item = prefix + item;
            })
            // 填写需要删除的多个Object完整路径并设置返回模式为简单模式。Object完整路径中不能包含Bucket名称。
            let result = await client.deleteMulti(fileNames, { quiet: true });
            console.log(result);
        } catch (e) {
            console.log(e);
        }
    }
}

function getHeader(File) {
    var headers = {
        // 指定该Object被下载时网页的缓存行为。
        // 'Cache-Control': 'no-cache', 
        // 指定该Object被下载时的名称。
        'Content-Disposition': `attachment; filename=${encodeURIComponent(File.fileName)}`,
        // 指定该Object被下载时的内容编码格式。
        // 'Content-Encoding': 'UTF-8', 
        // 指定过期时间。
        // 'Expires': 'Wed, 08 Jul 2022 16:57:01 GMT', 
        // 指定Object的存储类型。
        // 'x-oss-storage-class': 'Standard', 
        // 指定Object的访问权限。
        // 'x-oss-object-acl': 'private', 
        // 设置Object的标签，可同时设置多个标签。
        // 'x-oss-tagging': 'Tag1=1&Tag2=2', 
        // 指定CopyObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。
        // 'x-oss-forbid-overwrite': 'true', 
    };
    return headers;
}

export {
    ossUpload,
    ossPreview,
    ossDelete,
    ossAbortMultipartUpload
}

